// --- Hooks ---
import { useTiptapEditor } from "@/tiptap/hooks/use-tiptap-editor"

// --- Lib ---
import { isNodeTypeSelected } from "@/tiptap/lib/tiptap-utils"

// --- Tiptap UI ---
import { DeleteNodeButton } from "@/tiptap/ui/delete-node-button"
import { ImageDownloadButton } from "@/tiptap/ui/image-download-button"
import { ImageAlignButton } from "@/tiptap/ui/image-align-button"
import { ImageBorderButton } from "@/tiptap/ui/image-border-button"

// --- UI Primitive ---
import { Separator } from "@/tiptap/ui-primitive/separator"
import { ImageCaptionButton } from "@/tiptap/ui/image-caption-button"
import { ImageUploadButton } from "@/tiptap/ui/image-upload-button"
import { RefreshCcwIcon } from "@/tiptap/icons/refresh-ccw-icon"

export function ImageNodeFloating({
  editor: providedEditor
}) {
  const { editor } = useTiptapEditor(providedEditor)
  const visible = isNodeTypeSelected(editor, ["image"])

  if (!editor || !visible) {
    return null
  }

  return (
    <>
      <ImageAlignButton align="left" />
      <ImageAlignButton align="center" />
      <ImageAlignButton align="right" />
      <Separator />
      <ImageCaptionButton />
      <ImageBorderButton />
      <Separator />
      <ImageDownloadButton />
      <ImageUploadButton icon={RefreshCcwIcon} tooltip="Replace" />
      <Separator />
      <DeleteNodeButton />
    </>
  );
}
